import { useState } from "react";
import { useTranslation } from "react-i18next";

import PayByBank from "chameleon/icons/pay-by-bank";

import { imageSizing } from "checkout-experience/components/payment-method/pay-options/pay-by-bank/pay-by-bank-logo.css";

export const PayByBankLogo = ({ logoSrc }: { logoSrc?: string }) => {
  const { t } = useTranslation("combined");
  const [isLoadable, setIsLoadable] = useState<boolean>(true);
  const [hasLoaded, setHasLoaded] = useState<boolean>(false);

  // no src value just return the default
  // or if it fails to load just show the default
  if (!logoSrc || !isLoadable) {
    return (
      <PayByBank
        sizeVariant={24}
        isRectangle
        aria-label={t("payByBank.payByBank")}
      />
    );
  }

  return (
    <>
      <img //Load image hidden to check if it is successful before displaying
        src={logoSrc}
        alt={t("payByBank.logo")}
        className={imageSizing}
        style={
          !hasLoaded
            ? { visibility: "hidden", height: "0", width: "0", minWidth: "0" } // Make it not visible if loading isn't finished
            : {}
        }
        onLoad={() => {
          setIsLoadable(true);
          setHasLoaded(true);
        }}
        onError={() => {
          setIsLoadable(false);
        }}
        aria-label={t("payByBank.logo")}
      />
      {!hasLoaded ? ( // If not loaded show placeholders
        <PayByBank
          sizeVariant={24}
          isRectangle
          aria-label={t("payByBank.payByBank")}
        />
      ) : null}
    </>
  );
};
